import React, { useEffect } from "react";
import DeviceContext from "../../../../utils/indentifyDevice";
import TaxTable from "./TaxTable";
import ShowGains from "./ShowGains";
import CommonSummary from "../../CommonComponent/CommonSummary";
import "../../../../stylesheets/components/Reports/TAXReports/TaxSummary.scss";
import Skeleton from "react-loading-skeleton";
import CalendarPopupDesk from "@frameworks/web/components/generic/Calendar/CalendarPopupDesk";
import moment from "moment";
import { getFinancialYears } from "@domains/utils/reportDates";
import PopBodProcessBlock from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PopBodProcessBlock";
const TaxReport = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const financialYears = getFinancialYears(props.startDate, props.endDate);
    DeviceContext().isMobile &&
        require("../../../../stylesheets/components/Reports/TAXReports/TaxReports.scss");
    const ref = React.useRef(null);
    const [scrollPosition, setScrollPosition] = React.useState(0);
    React.useEffect(() => {
        window.addEventListener("scroll", () => setScrollPosition(window.pageYOffset));
        return () => {
            window.removeEventListener("scroll", () => setScrollPosition(window.pageYOffset));
        };
    }, []);
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                props.setOpenCalendar(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    return (React.createElement("section", { id: "tax" },
        React.createElement("div", null,
            !props.shimmer && ((_a = props.taxData.taxDataFlags) === null || _a === void 0 ? void 0 : _a.isBodEnabled) && (React.createElement(PopBodProcessBlock, { bodProcessInfoMessage: props.taxData.taxDataFlags.bodProcessInfoMessage })),
            React.createElement("div", { className: "calender-sub-section", ref: ref },
                React.createElement("div", { className: "calendar_date" },
                    React.createElement("div", { className: "displayFlex" },
                        React.createElement("div", { className: "fin_year" }, financialYears.label),
                        React.createElement("span", null,
                            "\u00A0(",
                            moment(props.startDate).format("D-MMM-YY"),
                            "\u00A0 to ",
                            moment(props.endDate).format("D-MMM-YY"),
                            ")"),
                        " ",
                        React.createElement("span", { className: "calendar_change" },
                            React.createElement("i", { className: "edel-icon-calendar2" }),
                            React.createElement("span", { onClick: () => props.setOpenCalendar(!props.openCalendar) }, "\u00A0Change")))),
                React.createElement("div", { className: "tax-calender secondary-navy-theme" },
                    React.createElement(CalendarPopupDesk, { openCalendar: props.openCalendar, setOpenCalendar: props.setOpenCalendar, startDate: props.startDate, endDate: props.endDate, finYear: props.finYear, setStartDate: props.setStartDate, setEndDate: props.setEndDate, setFinYear: props.setFinYear, customTime: true, setNextFinYear: props.setNextFinYear })))),
        React.createElement("div", { className: "tax-summary" }, props.shimmer ? (React.createElement("div", { className: "shimmer_skeleton" },
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 100, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 100, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 100, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 100, width: "100%", className: "align-top" })))) : (React.createElement(CommonSummary, { summaryData: [
                {
                    title: "Total Trading Gain",
                    value: (_c = (_b = props.taxData) === null || _b === void 0 ? void 0 : _b.taxSummary) === null || _c === void 0 ? void 0 : _c.tradingGain,
                    integer: false,
                    externalClassName: "tax-summary-container-one",
                },
                {
                    title: "Total short term Gain",
                    value: (_e = (_d = props.taxData) === null || _d === void 0 ? void 0 : _d.taxSummary) === null || _e === void 0 ? void 0 : _e.shortTermGain,
                    integer: false,
                    externalClassName: "tax-summary-container-one",
                },
                {
                    title: "Total long term Gain",
                    value: (_g = (_f = props.taxData) === null || _f === void 0 ? void 0 : _f.taxSummary) === null || _g === void 0 ? void 0 : _g.longTermGain,
                    integer: false,
                    externalClassName: "tax-summary-container-one",
                },
                {
                    title: "Total Gain",
                    value: (_j = (_h = props.taxData) === null || _h === void 0 ? void 0 : _h.taxSummary) === null || _j === void 0 ? void 0 : _j.totalGain,
                    integer: false,
                    externalClassName: "tax-summary-container-one",
                },
            ], dock: scrollPosition > 120 ? true : false }))),
        React.createElement(ShowGains, { startDate: props.startDate, endDate: props.endDate, finYear: props.finYear, taxReportError: props.taxReportError, emptyValidation: props.emptyValidation, shimmer: props.shimmer, accCode: props.accCode, openPopUp: props.openPopUp, setOpenPopup: props.setOpenPopup, setIsTaxHarvesting: props.setIsTaxHarvesting, isTaxHarvesting: props.isTaxHarvesting }),
        React.createElement(TaxTable, { mainCompShimmer: props.shimmer, taxDetailsData: (_k = props.taxData) === null || _k === void 0 ? void 0 : _k.taxDetail, taxReportError: props.taxReportError, emptyValidation: props.emptyValidation })));
};
export default TaxReport;
